import { inject } from "fw";
import { Store, handle } from "fw-state";

type CurrentConfirmStoreShape = {
    show: boolean;
    content: { title: string; message: string; actions: string[] | null };
};

export class SetDefaultConfirmStoreAction {}

export class ShowAction {
    constructor(public content: { title: string; message: string; actions: string[] | null }) {}
}

@inject
export class ConfirmStore extends Store<CurrentConfirmStoreShape> {
    constructor() {
        super();
    }

    defaultState() {
        return {
            show: false,
            content: {
                title: "Confirm",
                message: null,
                actions: null
            }
        };
    }

    @handle(ShowAction)
    private async handleShowModalAction(action: ShowAction) {
        this.setState(() => ({
            ...this.state,
            show: true,
            content: action.content
        }));
    }

    @handle(SetDefaultConfirmStoreAction)
    private async handleSetDefaultConfirmStoreAction() {
        this.setState(() => ({
            ...this.defaultState()
        }));
    }
}
